
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import axiosCommonInstance from '../../../utils/axios/axiosCommonInstance'
import PannellumViewer from '../PannellumViewer'
import Preview360 from '../Preview360'
import FullPannellumViewer from '../FullPannellumView'

const Viewview360 = () => {
  const { id } = useParams()
  const [view360, setView360] = useState(null)
  const [loading, setLoading] = useState(true)

  const fetchview360Data = async () => {
    try {
      const response = await axiosCommonInstance.get(`view360/detail/${id}`)
      setView360(response.data.result)
    } catch (error) {
      console.error('Error fetching view360 data:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchview360Data()
  }, [id])

  if (loading) {
    return <div>Loading...</div>
  }

  if (!view360) {
    return <div>No view360 data found.</div>
  }

  return (
    <div className='w-full'>
      {view360?.view === 'detail' ?
        <PannellumViewer
          data={view360}
          product={view360?.product}
        /> :
        <FullPannellumViewer
          data={view360}
        />
      }
      {/* <Preview360
        viewImg={view360.image}
        tileImg={view360.product.cover_photo}
        grout={view360?.groutSize}
        color={view360?.color?.code}
        className='max-w-full max-h-full'
      /> */}
    </div>
  )
}

export default Viewview360
